import React from 'react';
import { ManagedByMessage } from '@components/ManagedByMessage/ManagedByMessage';
import { PermittedAction } from '@utilities/PermittedAction';
import useGetAccessor from '@components/CaseDetails/CaseInUse/hooks/useGetAccessor/useGetAccessor';
import { UserAccessEnum } from '@interfaces/SurgeryRequest/UserAccessEnum';


export const CaseInUseMessage = () => {
	const { blockerName: currentlyInUseBy } = useGetAccessor([UserAccessEnum.CONFIRMER], PermittedAction.CONFIRM_CASE_SCHEDULE);

	return (
		<ManagedByMessage managedByName={currentlyInUseBy}/>
	);
};
